import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Leasing } from '../../components/mechanization/leasing'; 

const LeasingPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Лизинг техники</title>
            </Helmet>
            <Leasing/>
        </>
    );
};

export default LeasingPage
